export default __webpack_public_path__ + "static/media/Izmir-Medium.9c40c14b.woff";